import Grid from "@mui/material/Grid";
import { ClientAgendaApiData } from "./type";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import React, { useEffect } from "react";
import AgendaPrevDescription from "../../project-agenda/project-agenda-description/AgendaDescription";

type Props = {
    expertData: ClientAgendaApiData["experts"]
}

export default function ExpertTab({expertData}: Props) {
    const [expert, setExpert] = React.useState<ClientAgendaApiData["experts"][0]>(expertData[0]);

    const handleChange = (event: React.MouseEvent<HTMLElement>, nextExpert: ClientAgendaApiData["experts"][0]) => {
        if(nextExpert) {
            setExpert(nextExpert);
        }
    };

    return (
        <>
        <Grid container>
            <Grid item xs={12} sm={3} sx={{overflow: "scroll", height: {
                sm: "500px",
                xs: "initial"
            }, maxHeight: {xs: "200px", sm: "500px"}}}>
            <ToggleButtonGroup
                orientation="vertical"
                value={expert}
                exclusive
                onChange={handleChange}
                fullWidth
                >
                    {expertData.map(d => 
                        <ToggleButton sx={{textTransform: "capitalize"}} value={d} aria-label={d.expert_name}>
                            {d.expert_name}
                        </ToggleButton>
                    )}
                </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12} sm={9} sx={{overflow: "scroll", border: "1px solid #252B3B75", height: "500px"}}>
                {expert &&
                    <AgendaPrevDescription
                        fk_agenda={expert.fk_agenda}
                        agenda_responses={expert.agenda_responses}
                        handleClose={() => {}}
                        editBtnClickHandler={() => {}}
                        isAdminAllowed={false}
                        isProjectOpen={false}
                        showEditCancelBtn={false}
                    />
                }
            </Grid>
        </Grid>
    </>
    )
}